// form-validation.service.ts
import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { VALIDATOR_MESSAGES } from '@core/constants/messages/validator-messages.constants';
import { PATTERNS } from '@core/constants/patterns.constant';
// import { Country } from "@core/models/commom/country-selector.model";
export interface Country {
    name: string;
    dialCode: string;
    minLength: number;
    maxLength: number;
  }
@Injectable({
  providedIn: 'root',
})
export class FormValidation {
  getValidationMessage(control: AbstractControl, controlName: string): string | null {
    if (control?.errors) {
      if (control.errors['required']) {
        return VALIDATOR_MESSAGES.REQUIRED;
      }
      if (control?.errors['requiredTrue']) {
        return VALIDATOR_MESSAGES.AGREE_TERMS;
      }
      if (control.errors['min']) {
        return VALIDATOR_MESSAGES.MIN(control.errors['min'].min);
      }
      if (control.errors['max']) {
        return VALIDATOR_MESSAGES.MAX(control.errors['max'].max);
      }
      if (control.errors['minlength']) {
        return VALIDATOR_MESSAGES.MIN_LENGTH(control.errors['minlength'].requiredLength);
      }
      if (control.errors['maxlength']) {
        return VALIDATOR_MESSAGES.MAX_LENGTH(control.errors['maxlength'].requiredLength);
      }
      if (control.errors['pattern']?.requiredPattern === PATTERNS.EMAIL_NO_WHITESPACE.toString()) {
        return VALIDATOR_MESSAGES.EMAIL_NO_WHITESPACE;
      }
      if (control.errors['email']) {
        return VALIDATOR_MESSAGES.INVALID_EMAIL;
      }
      if (control.errors['passwordMismatch'] && controlName === 'confirmPassword') {
        return VALIDATOR_MESSAGES.PASSWORD_MATCH;
      }

      if (control.errors['pattern']) {
        const pattern = control.errors['pattern'].requiredPattern;
        if (pattern) {
          switch (pattern) {
            case PATTERNS.NO_SPECIAL_CHAR.toString():
              return VALIDATOR_MESSAGES.WITHOUTSPECIALCHAR;
            case PATTERNS.WEBSITE_URL.toString():
              return VALIDATOR_MESSAGES.INVALID_WEBSITE_URL;
            case PATTERNS.POSTAL_CODE.toString():
              return VALIDATOR_MESSAGES.INVALID_POSTAL_CODE;
            case PATTERNS.MOBILE_NUMBER.toString():
              return VALIDATOR_MESSAGES.INVALID_MOBILE_NUMBER;
            case PATTERNS.ALPHABET_WITH_SPACE.toString():
              return VALIDATOR_MESSAGES.INVALID_ALPHABET_WITH_SPACE;
            case PATTERNS.ALPHABET_WITH_SPACE_AND_NUMBER.toString():
              return VALIDATOR_MESSAGES.INVALID_ALPHABET_WITH_SPACE_AND_NUMBER;
            case PATTERNS.ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR.toString():
              return VALIDATOR_MESSAGES.INVALID_ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR;
            case PATTERNS.ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR_AND_HYPHEN.toString():
              return VALIDATOR_MESSAGES.INVALID_ALPHABET_WITH_SPACE_AND_NUMBER_AND_SPECIAL_CHAR_AND_HYPHEN;
            case PATTERNS.PASSWORD.HAS_LOWERCASE.toString():
              return VALIDATOR_MESSAGES.PASSWORD.HAS_LOWERCASE;
            case PATTERNS.PASSWORD.HAS_UPPERCASE.toString():
              return VALIDATOR_MESSAGES.PASSWORD.HAS_UPPERCASE;
            case PATTERNS.PASSWORD.HAS_NUMBER.toString():
              return VALIDATOR_MESSAGES.PASSWORD.HAS_NUMBER;
            case PATTERNS.PASSWORD.HAS_SPECIAL_CHAR.toString():
              return VALIDATOR_MESSAGES.PASSWORD.HAS_SPECIAL_CHAR;
            case PATTERNS.PASSWORD.VALID_CHAR_SET.toString():
              return VALIDATOR_MESSAGES.PASSWORD.VALID_CHAR_SET;
            case PATTERNS.PASSWORD.MIN_LENGTH.toString():
              return VALIDATOR_MESSAGES.PASSWORD.MIN_LENGTH;
            case PATTERNS.COMMON_ID.toString():
              return VALIDATOR_MESSAGES.INVALID_APP_ID;
            case PATTERNS.EMAIL_NO_WHITESPACE.toString():
              return VALIDATOR_MESSAGES.EMAIL_NO_WHITESPACE;
            default:
              return null;
          }
        }
      }
    }
    return null;
  }

    phoneWithCountryValidator(getCountries: () => Country[]): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
        const parent = control.parent;
        if (!parent) return null;

        const countryCode = parent.get("countryCode")?.value;
        const phoneNumber: string = control.value || "";

        if (!countryCode || !phoneNumber) return null;

        const countries = getCountries();
        const selectedCountry = countries.find((c) => c.dialCode === countryCode);
        if (!selectedCountry) return null;

        const isValidLength =
          phoneNumber.length >= selectedCountry.minLength &&
          phoneNumber.length <= selectedCountry.maxLength;

        return isValidLength
          ? null
          : {
              invalidPhoneCountry: {
                minLength: selectedCountry.minLength,
                maxLength: selectedCountry.maxLength,
              },
            };
      };
    }

  getErrorMessage(control: AbstractControl | null): string {
    if (!control) return '';

    if (control.hasError('required')) {
      return 'This field is required';
    }

    if (control.hasError('email')) {
      return 'Please enter a valid email address';
    }

    return '';
  }
}
